import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import LandingPage from "../components/LandingPage";
import AboutUsPage from "../components/AboutUsPage";
import ServicePage from "../components/ServicePage";
import ContactUsPage from "../components/ContactUsPage";
import NotFoundPage from "../components/NotFoundPage";
import ProductPage from "../components/ProductPage";

import TrainingRegistation from "../components/TrainingRegistartion";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          <PublicRoute path="/" component={LandingPage} exact={true} />
          <PublicRoute path="/about" component={AboutUsPage} />
          <PublicRoute path="/service" component={ServicePage} />
          <PublicRoute path="/contact" component={ContactUsPage} />
          <PublicRoute path="/product" component={ProductPage} />
          <Route
            path="/industrytrainings"
            component={TrainingRegistation}
          ></Route>
          <Route component={NotFoundPage}></Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default AppRouter;
